// extracted by mini-css-extract-plugin
module.exports = {"experience":"Experience-module--experience--18Psw","wrapper":"Experience-module--wrapper--2Grtf","text":"Experience-module--text--yZghQ","stats":"Experience-module--stats--1ylOb"};